const TermsSection = () => {
  return (
    <section className="pf-terms-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <div className="pf-terms-wrap">
              <div className="pf-terms-text">
                <p>
                  These Terms and Conditions ("Terms") are entered into by and between JSA Online ("JSA Online," "we," or "our") and the customer ("you" or "your") for the provision of Cash Flow Management Services. By using our services, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use our services.
                </p>

                <h2>1. Service Agreement</h2>
                <p><strong>1.1. Services:</strong> JSA Online agrees to provide Cash Flow Management Services as described in the service agreement or proposal provided to you.</p>
                <p><strong>1.2. Payment:</strong> You agree to pay for the services in accordance with the terms and pricing specified in the service agreement or proposal.</p>

                <h2>2. Confidentiality</h2>
                <p><strong>2.1. Non-Disclosure:</strong> JSA Online agrees to keep all information and data provided by you confidential and will not disclose it to third parties, except as required to perform the services or as required by law.</p>

                <h2>3. Responsibilities</h2>
                <p><strong>3.1. Client Responsibilities:</strong> You are responsible for providing accurate and timely information required for the provision of Cash Flow Management Services.</p>
                <p><strong>3.2. Compliance:</strong> You agree to comply with all applicable laws and regulations related to your financial activities.</p>

                <h2>4. Payment Terms</h2>
                <p><strong>4.1. Payment Obligations:</strong> Payment terms, including fees, invoicing, and payment schedules, are outlined in the service agreement or proposal.</p>
                <p><strong>4.2. Late Payments:</strong> In the event of late payments, JSA Online may suspend or terminate services.</p>

                <h2>5. Termination</h2>
                <p><strong>5.1. Termination by JSA Online:</strong> JSA Online reserves the right to terminate services if you breach these Terms or for any other valid reason outlined in the service agreement.</p>
                <p><strong>5.2. Termination by You:</strong> You may terminate services by providing written notice in accordance with the service agreement terms.</p>

                <h2>6. Limitation of Liability</h2>
                <p><strong>6.1. No Guarantees:</strong> JSA Online does not guarantee any specific financial results, and you agree that our services are provided "as is" without any warranties.</p>

                <h2>7. Governing Law</h2>
                <p><strong>7.1. Applicable Law:</strong> These Terms are governed by the laws of Delhi, and any disputes will be subject to the exclusive jurisdiction of the courts in Delhi.</p>

                <h2>8. Changes to Terms</h2>
                <p><strong>8.1. Modification:</strong> JSA Online reserves the right to modify these Terms at any time. Updated Terms will be posted on our website, and it is your responsibility to review them regularly.</p>

                <h2>9. Contact Information</h2>
                <p><strong>9.1. Contact:</strong> For questions or concerns regarding these Terms or our services, you can contact us using the details below.</p>
                <p>
                  <strong>Mr. Jagmohan Singh</strong><br />
                  (Grievance Officer)<br />
                  <a href="http://jsa.net.in" target="_blank" rel="noopener noreferrer">http://jsa.net.in</a><br />
                  Jagmohan Singh &amp; Associates<br />
                  Email: <a href="mailto:mail@jsa.net.in">mail@jsa.net.in</a><br />
                  Ph: +011-41588008
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TermsSection;
